import React, { useState, useEffect, useMemo } from 'react'
import { Input, Spin, Button, Select, message, Modal, Checkbox } from 'antd'
import R from 'ramda'
import MultiCauseCodePropmt from '../../MultiCauseCode'
import moment from 'moment'
import {
  // postCard97,
  getCard97Idx,

  // getCard97ExtensionData
} from 'api/pgads'
import { connect } from 'react-redux'

import {
  // getDataCheckServiceByclient,
  getSaveServiceByClient,
  // getDeleteServiceByClient,
  getExtensionDataByClient,
} from './../../getServiceUtil'

import { getExpandedKeys, setDstZone } from './Card97EditAntd'

import { getUnitCodeCauseCodeMapList } from 'core'
import { fixDescriptionValue } from '../../utils'
// import { isErrorContainsTmpError } from 'core/component/JcTmpErrorDialog'

const QuickFill = ({
  CLIENT = 'INTEG',
  ampCodeMap,
  failCodeMap,
  utility,
  unit,
  targetInfo,
  causeCode,
  // causeCodeDescription,
  description,
  visible,
  failCode,
  ampCode,
  unitCodeMap,
  data,
  year,
  eventNum,
  unitsList,
  timeZoneMap,
  ...props
}) => {
  const [causeCodeChecked, setCauseCodeChecked] = useState(false)
  const [failCodeChecked, setFailCodeChecked] = useState(false)
  const [causeCodeText, setCauseCodeText] = useState()
  const [showCauseCodeDialog, setShowCauseCodeDialog] = useState(false)
  const [descriptionChecked, setDescriptionChecked] = useState(false)
  const [descriptionText, setDescrptionText] = useState('')
  const [failCodeSelect, setFailCodeSelect] = useState(failCode)
  const [ampCodeSelect, setAmpCodeSelect] = useState(ampCode)
  const [idxData, setIdxData] = useState([])

  const unitCodeCauseCodeMap = useMemo(
    _ => getUnitCodeCauseCodeMapList(props.causeCodeList || []),
    [props.causeCodeList]
  )

  const [causeCodeTreeVal, setCauseCodeTreeVal] = useState(
    getExpandedKeys(unitCodeCauseCodeMap)(unitCodeMap[unit], causeCode)
  )

  const [extensionData, setExtensionData] = useState({
    year,
    utility,
    unitId: unit,
    eventNum,
    unit: unit.substring(utility.length),
  })
  useEffect(
    _ => {
      getCard97Idx(targetInfo)(
        year,
        utility,
        unit,
        eventNum
      ).fork(props.setError, data => setIdxData(data))
      getExtensionDataByClient(CLIENT)(targetInfo)({
        year,
        eventNum,
        unitId: unit,
      }).fork(props.setError, data => {
        if (data.length > 0) setExtensionData(data[0])
      })
    },
    [CLIENT, eventNum, props.setError, targetInfo, unit, utility, year]
  )

  const getValue = _ => ({
    causeCode: causeCodeChecked ? causeCodeText : causeCode,
    failCode: failCodeChecked ? failCodeSelect : failCode,
    ampCode: failCodeChecked ? ampCodeSelect : ampCode,
    description: (
      (descriptionChecked ? descriptionText : description) || ''
    ).trim(),
    mode: 'E',
  })

  const failAmpCodeOption = R.compose(
    R.map(([key, text]) => ({ key, text, value: key })),
    R.sortBy(([_, text]) => text.toLowerCase()),
    R.toPairs
  )

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setShowCauseCodeDialog(false)
    setCauseCodeText(
      causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : causeCode
    )
  }
  const setMsg = m => {
    message.error(m)
  }

  // const setDstZone = (date, dateZone, unit) =>
  //   dateZone ||
  //   (date
  //     ? moment(
  //         moment(date).format('MM/DD/YYYY HH:mm'),
  //         'MM/DD/YYYY HH:mm'
  //       ).isDST()
  //       ? props.timeZoneMap &&
  //         props.timeZoneMap[unit] &&
  //         `${props.timeZoneMap[unit].substring(0, 1)}D${props.timeZoneMap[
  //           unit
  //         ].substring(2, 3)}`
  //       : props.timeZoneMap && props.timeZoneMap[unit]
  //     : '')

  const saveData = dataSave => {
    if (!(causeCodeChecked || failCodeChecked || descriptionChecked)) {
      message.warning('Please, Update data to save')
      return
    }
    const { mode = 'E', unitShortNameMap } = props
    const {
      availCap,
      utility,
      unit,
      year,
      // eslint-disable-next-line no-unused-vars
      causeCode,
      eventType,
      eventNum,
      eventStart,
      eventEnd,
      workStart,
      workEnd,
      ampCode,
      failCode,
    } = dataSave

    if (
      utility === undefined ||
      unit === undefined ||
      utility == null ||
      unit == null
    ) {
      message.error('Please,Select Unit')
      return
    }
    // if (!causeCode) {
    //   message.error('Please,Select CauseCode')
    //   return
    // }
    if (!eventType) {
      message.error('Please,Select EventType')
      return
    }
    if (!eventStart) {
      message.error('Please,Select Event Start Time')
      return
    }
    let avlCap = availCap && availCap.trim()
    avlCap = avlCap ? (avlCap === 'NC' ? -1 : avlCap) : 0

    if (eventNum && eventNum.length > 4) {
      setMsg(
        'Event Number field can only contain numeric value less than 10000'
      )
    } else if (isNaN(avlCap)) {
      setMsg(
        'Available Capacity field can only contain "NC" as string besides numeric value'
      )
    } else if (
      ampCode &&
      ampCode.trim().length > 0 &&
      ampCode.trim().length !== 2
    ) {
      setMsg('Amplification Code can only have two characters.')
    } else if (
      failCode &&
      failCode.trim().length > 0 &&
      failCode.trim().length !== 4
    ) {
      setMsg('Fail Code can only have four characters.')
    } else {
      const tableData =
        idxData.length > 0
          ? idxData
              .filter(c => c.causeCode && c.causeCode.length > 0)
              .map((d, i) => ({
                utility,
                unit,
                year,
                eventNum:
                  eventNum && eventNum.length > 0 && eventNum.length <= 4
                    ? eventNum
                    : -1,
                eventIdx: i + 1,
                causeCode: d.causeCode,
                conCode: d.conCode ? d.conCode : '',
                failCode: d.failCode ? d.failCode : '',
                ampCode: d.ampCode ? d.ampCode : '',
                description: d.description ? d.description : '',
              }))
          : []

      const eventStartZone = setDstZone(
        eventStart,
        dataSave.eventStartZone,
        timeZoneMap,
        unit,
        unitsList
      )
      const eventEndZone = setDstZone(
        eventEnd,
        dataSave.eventEndZone,
        timeZoneMap,
        unit,
        unitsList
      )
      const workStartZone = setDstZone(
        workStart,
        dataSave.workStartZone,
        timeZoneMap,
        unit,
        unitsList
      )
      const workEndZone = setDstZone(
        workEnd,
        dataSave.workEndZone,
        timeZoneMap,
        unit,
        unitsList
      )
      const data = [
        {
          workStartZone,
          workEndZone,
          eventEndZone,
          eventStartZone,
          mode: mode === 'N' ? 1 : 0,
          shortName: unitShortNameMap[unit],
          utility,
          unit,
          year,
          eventNum: eventNum || -1,
          eventIdx: mode === 'D' ? 1 : 0,
          eventType: eventType || '',
          ioCode: dataSave.ioCode === 'Y' ? -1 : 0,
          eventStart: dataSave.eventStart
            ? moment(dataSave.eventStart).format('MM/DD/YYYY HH:mm')
            : '',
          //          eventStartZone: dataSave.eventStartZone ? dataSave.eventStartZone : '',
          eventEnd: dataSave.eventEnd
            ? moment(dataSave.eventEnd).format('MM/DD/YYYY HH:mm')
            : '',
          //        eventEndZone: dataSave.eventEndZone ? dataSave.eventEndZone : '',
          availCap: avlCap,
          causeCode: dataSave.causeCode ? dataSave.causeCode : null,
          conCode: dataSave.conCode ? dataSave.conCode : '',
          workStart: dataSave.workStart
            ? moment(dataSave.workStart).format('MM/DD/YYYY HH:mm')
            : '',
          // workStartZone: dataSave.workStartZone ? dataSave.workStartZone : '',
          workEnd: dataSave.workEnd
            ? moment(dataSave.workEnd).format('MM/DD/YYYY HH:mm')
            : '',
          // workEndZone: dataSave.workEndZone ? dataSave.workEndZone : '',
          manHour:
            dataSave.manHour && dataSave.manHour.length > 0
              ? dataSave.manHour
              : 0,
          description: dataSave.description ? dataSave.description : '',
          failCode: dataSave.failCode ? dataSave.failCode : '',
          ampCode: dataSave.ampCode ? dataSave.ampCode : '',
          delta: 0.0,
          extensionData: {
            ...extensionData,
            // unit: extensionData.unitId.substring(extensionData.utility.length),
          },
        },
        ...tableData,
      ]

      props.setSpinning(true)
      getSaveServiceByClient(CLIENT)(targetInfo)(data).fork(
        e => props.setError(e, props.onCancel),
        saveStatusData => {
          props.setSpinning(false)
          const isArray = Array.isArray(saveStatusData)
          const errorData = isArray ? saveStatusData : saveStatusData.errorData
          const curCard = isArray ? [] : saveStatusData.dataForSingleEventNumber

          // const isError = isErrorContainsTmpError(errorData)

          if (errorData.length > 0) {
            // const onlyWarning = data.every(d => d.severity == 0)
            // props.onCancel(false)
            props.setErrorSaveData(errorData)
            props.setErrorPropmt(true)
          } else {
            message.info('Data saved Successfully')
            props.onCancel(false)
            if (isArray) props.retrieveData({})
            else {
              props.setData && props.setData(curCard, 'U')
            }
          }
        }
      )
    }
  }

  return (
    <Modal
      title="Quick Fill"
      visible={visible}
      onOk={_ => saveData({ ...data, ...getValue() })}
      onCancel={props.onCancel}
      bodyStyle={{
        display: 'grid',
        // gridTemplateColumns: '130px 200px 100px',
        // gridGap: '10px',
      }}
      width={900}
      height={400}
      style={{ top: 10 }}
      okText="Save"
      spinning={props.spinning}
      confirmLoading={props.spinning}
    >
      <Spin spinning={props.spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '130px 200px max-content',
            gridGap: '10px',
          }}
        >
          <Checkbox
            checked={causeCodeChecked}
            onChange={e => {
              setCauseCodeChecked(e.target.checked)
            }}
          >
            Cause Code
          </Checkbox>
          <Input
            disabled={!causeCodeChecked}
            value={causeCodeChecked ? causeCodeText : causeCode}
            onChange={e => {
              setCauseCodeText(e.target.value)
              setCauseCodeTreeVal(
                getExpandedKeys(unitCodeCauseCodeMap)(
                  unitCodeMap[unit],
                  e.target.value
                )
              )
            }}
          />
          <Button
            style={{ minWidth: '150px', maxWidth: '150px' }}
            disabled={!causeCodeChecked}
            onClick={_ => setShowCauseCodeDialog(true)}
          >
            Select
          </Button>
          <Checkbox
            checked={failCodeChecked}
            onChange={e => setFailCodeChecked(e.target.checked)}
          >
            Fail Code
          </Checkbox>

          <Select
            style={{ gridColumnEnd: 'span 2', minWidth: '700px' }}
            placeholder="Fail Code"
            onChange={value => setFailCodeSelect(value)}
            value={failCodeChecked ? failCodeSelect : failCode}
            disabled={!failCodeChecked}
          >
            {failAmpCodeOption(failCodeMap).map(({ key, value, text }) => (
              <Select.Option value={value} key={key}>
                {text}
              </Select.Option>
            ))}
          </Select>

          <div>Amplification Code</div>
          <Select
            style={{ gridColumnEnd: 'span 2' }}
            placeholder="Amplification Code"
            onChange={value => setAmpCodeSelect(value)}
            value={failCodeChecked ? ampCodeSelect : ampCode}
            disabled={!failCodeChecked}
          >
            {failAmpCodeOption(ampCodeMap).map(({ key, value, text }) => (
              <Select.Option value={value} key={key}>
                {text}
              </Select.Option>
            ))}
          </Select>
          <Checkbox
            style={{ gridColumnEnd: 'span 3' }}
            checked={descriptionChecked}
            onChange={e => setDescriptionChecked(e.target.checked)}
          >
            Event Description
          </Checkbox>
          <Input.TextArea
            disabled={!descriptionChecked}
            style={{ gridColumnEnd: 'span 3' }}
            value={descriptionChecked ? descriptionText : description}
            rows={4}
            maxLength={300}
            onChange={e => {
              let value = e.target.value

              value = fixDescriptionValue(value)
              setDescrptionText(value)
            }}
          />

          {showCauseCodeDialog && (
            <MultiCauseCodePropmt
              causeCodeList={props.causeCodeList}
              key="card97Quickfillprompt"
              // style={{ ...inlineStyle }}
              // checkable={false}
              visibleDialog={showCauseCodeDialog}
              onDialogClose={onCauseCodeDialogClose}
              onCancelAction={_ => setShowCauseCodeDialog(false)}
              // defaultExpandedKeys={causeCode ? causeCode.selectedKeys : []}
              defaultExpandedKeys={causeCodeTreeVal.causeCodeKeyValues || []}
              selectedKeys={causeCodeTreeVal.causeCodeKeyValues || []}
              selectedValues={causeCodeTreeVal.causeCodeValues || []}
              unitCodes={[unitCodeMap[unit]]}
              multiple={false}
              checkable={false}
              selectable
            />
          )}
        </div>
      </Spin>
    </Modal>
  )
}

const mapStateToProps = _ => ({})

export default connect(mapStateToProps)(QuickFill)
